import React, { ComponentProps } from "react";
import { Text, Box, Flex, Button } from "@thenounproject/lingo-core";
import { Container, InnerMedium } from "../Elements";
import MarketingText from "../MarketingText";

type Props = {
  title: string;
  subtitle?: string;
  style?: "light" | "dark";
  // gap?: string;
  level?: "h1" | "h2" | "h3";
  primaryButton?: Partial<ComponentProps<typeof Button>>;
  secondaryButton?: Partial<ComponentProps<typeof Button>>;
} & React.ComponentProps<typeof Box>;

const TitleSection: React.FC<Props> = ({
  title,
  subtitle,
  style = "light",
  level,
  primaryButton,
  secondaryButton,
  ...rest
}) => {
  return (
    <Container background={style === "dark" ? "primary" : null} mt="none" py="xxl" {...rest}>
      <InnerMedium textAlign="center" first>
        <Title
          title={title}
          subtitle={subtitle}
          style={style}
          level={level}
          primaryButton={primaryButton}
          secondaryButton={secondaryButton}
        />
      </InnerMedium>
    </Container>
  );
};
export default TitleSection;

export const Title: React.FC<Props> = ({
  title,
  subtitle,
  style = "light",
  level = "h1",
  primaryButton,
  secondaryButton,
  ...rest
}) => {
  const color = {
    dark: "white",
    light: "black",
  }[style];

  function renderButtons() {
    if (primaryButton || secondaryButton) {
      return (
        <Flex mt="l" gap="16px">
          {primaryButton && (
            <Button
              themeOverrides={{
                primaryColor: "white",
                primaryColorDark: "grayLight",
                primaryColorTint: "black",
              }}
              buttonStyle="primary"
              {...primaryButton}
            />
          )}
          {secondaryButton && (
            <Button
              themeOverrides={{ outlineStyle: "dark" }}
              buttonStyle="outline"
              {...secondaryButton}
            />
          )}
        </Flex>
      );
    }
  }

  return (
    <Flex textAlign="center" {...rest} flexDirection="column" alignItems="center">
      <Text as={level} color={color} font={`marketing.${level}`}>
        {title}
      </Text>
      <MarketingText color={color} font={"marketing.bodyLarge"} mt="m">
        {subtitle}
      </MarketingText>
      {renderButtons()}
    </Flex>
  );
};
